export default __webpack_public_path__ + "static/media/people-with-hands-raised.dd002260.svg";